import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';

import { colors } from '../../colors';
import { ChevronDownIcon } from '../../icons/chevronDown';
import './style.scss';

interface Props {
    onChange: (e: MultiSelectChangeEvent) => void
    value: { label: string; value: string; }[]
    option: { label: string, value: string }[]
    placeholder?: string
    disabled?: boolean
    error?: boolean
    errorLabel?: string
    selectAllLabel: string
    maxLength?: number
    maxSelectedLabel?: number
    label?: string
    required?: boolean
}

const fontBase = {
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '150%',
}

export default function MultiSelectCheckbox(props: Props) {
    return (
        <div className="w-full flex flex-col gap-[4px]" style={{ textAlign: 'left' }}>
            {props.label && (
                <span className="text-left text-label-md font-semibold text-brandPrimary-800">
                    {props.label}
                    {props.required && <span className="text-red-500"> *</span>}
                </span>
            )}
            <MultiSelect
                value={props.value}
                onChange={props.onChange}
                options={props.option}
                optionLabel="label"
                placeholder={props.placeholder}
                maxSelectedLabels={props.maxSelectedLabel ?? 6}
                maxLength={props.maxLength}
                selectAllLabel={props.selectAllLabel}
                emptyMessage="Non è disponibile nessuna opzione"
                selectedItemsLabel="{0} selezionati"
                disabled={props.disabled}
                dropdownIcon={<ChevronDownIcon size={20} color={colors.neutral[300]} />}
                pt={{
                    root: {
                        style: {
                            minHeight: '48px',
                            width: '100%',
                            borderRadius: '8px',
                            border: props.error
                                ? `1px solid ${colors.red[500]}`
                                : `1px solid ${colors.neutral[300]}`,
                            backgroundColor: props.disabled ? 'rgba(242,242,250,1)' : colors.white,
                            boxShadow: '0px 1px 2px 0px hsla(220, 29%, 5%, 0.05)',
                            padding: '0 12px',
                            display: 'flex',
                            alignItems: 'center',
                            cursor: props.disabled ? 'not-allowed' : 'pointer',
                        }
                    },
                    labelContainer: {
                        style: {
                            padding: 0,
                            overflow: 'auto',
                            flex: 1,
                        }
                    },
                    label: {
                        style: {
                            ...fontBase,
                            color: props.value?.length ? colors.neutral[900] : colors.neutral[500],
                            padding: 0,
                        }
                    },
                    trigger: {
                        style: {
                            width: 'auto',
                            color: colors.neutral[500],
                        }
                    },
                    token: {
                        style: {
                            ...fontBase,
                            fontSize: '14px',
                            backgroundColor: colors.brandPrimary[200],
                            border: `1px solid ${colors.brandPrimary[400]}`,
                            borderRadius: '8px',
                            padding: '0 8px',
                            color: colors.neutral[900],
                        }
                    },
                    removeTokenIcon: {
                        style: {
                            color: colors.neutral[500],
                        }
                    },
                }}
            />
            {props.error && (
                <span className="text-sm font-semibold text-red-500 text-left">
                    {props.errorLabel}
                </span>
            )}
        </div>
    );
}